import "./Testimonial.css";
import { Card } from "@tennr/frontend/components/Card";

type TestimonialProps = {
  quote: string;
  image: string;
  attributedTo: string;
  attributedToTitle: string;
};

export const Testimonial = ({ quote, image, attributedTo, attributedToTitle }: TestimonialProps) => {
  return (
    <Card className="testimonial" size="lg">
      <p className="testimonial-quote">{quote}</p>
      <div className="testimonial-author">
        <img className="testimonial-author-image" src={image} alt="" draggable={false} />
        <p className="testimonial-author-text">
          {attributedTo}
          <br />
          {attributedToTitle}
        </p>
      </div>
    </Card>
  );
};
